<header class="header">
  <div class="container h-100">
    <div class="d-flex justify-content-between h-100">
      <a href="/" aria-label="valg logo" class="header-logo">
        <svg alt="Valg.dk's logo" fill="none" viewBox="0 0 86 63" xmlns="http://www.w3.org/2000/svg" title="valg logo">
          <path d="M79.132 56.123H38.799l-11.526-20.33-4.857 4.878 7.923 12.354-12.323-7.956-4.797 4.837 10.79 6.217H6.868L0 63h86l-6.868-6.877Z"
                fill="#F6F6F6"/>
          <path
            d="m48.515 49.467-2.03-3.058 3.383-3.399 3.066 2 5.057-5.078-22.217-12.714-4.997 5.018 12.681 22.289 5.057-5.058Zm-8.52-12.954 4.996 3.299-1.712 1.719-3.285-5.018ZM70.113 27.758l-4.22-4.238-5.713 5.717L46.96 15.964l-4.778 4.797 17.44 17.532 10.49-10.535ZM77.778 20.601c3.484-3.498 4.24-8.076-1.254-13.593l-2.548-2.56-6.47 6.518 3.823 3.838 1.692-1.7c1.174 1.28 1.234 2.38.457 3.16-.855.859-2.528 1.178-6.47-2.76-3.98-3.998-3.583-5.757-2.806-6.536.517-.52 1.334-.86 3.344.12l4.101-5.098c-5.116-3.138-8.899-2.239-11.566.44-3.584 3.598-4.977 8.716 2.15 15.872 7.087 7.117 11.944 5.917 15.547 2.299Z"
            fill="#F6F6F6"/>
        </svg>
      </a>
      <div *ngIf="shortElectionTitle || longElectionTitle" class="header-information">
        <h1 class="valg-dk-header-title header-title hidden__md-up">{{shortElectionTitle}}</h1>
        <h1 class="valg-dk-header-title header-title hidden__md-down">{{longElectionTitle}}</h1>
      </div>
    </div>
  </div>
</header>
